const SDK_VERSION = '8.33.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
